module.exports = __webpack_public_path__ + "static/media/HUANJING 1A (HJ-1A).c899f2b7.czml";